import React from 'react';
import Sym from './Sym';

/**
 * Control segmentado de tema (claro / auto / oscuro) — replica el del diseño.
 * Controlado: recibe `mode` y `onChange`.
 */
const SEGMENTS = [
  { key: 'light', icon: 'light_mode', label: 'Claro' },
  { key: 'auto', icon: 'brightness_auto', label: 'Automático' },
  { key: 'dark', icon: 'dark_mode', label: 'Oscuro' },
];

const ThemeToggle = ({ mode = 'auto', onChange }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 3,
      padding: 3,
      borderRadius: 999,
      border: '1px solid var(--border-2)',
      background: 'var(--ghost-bg)',
    }}
  >
    {SEGMENTS.map((s) => {
      const active = mode === s.key;
      return (
        <button
          key={s.key}
          type="button"
          onClick={() => onChange && onChange(s.key)}
          aria-label={s.label}
          aria-pressed={active}
          title={s.label}
          style={{
            width: 34,
            height: 30,
            display: 'grid',
            placeItems: 'center',
            border: 'none',
            borderRadius: 999,
            cursor: 'pointer',
            transition: 'background .18s, color .18s',
            background: active ? '#2F6BFF' : 'transparent',
            color: active ? '#fff' : 'var(--muted)',
          }}
        >
          <Sym name={s.icon} size={19} />
        </button>
      );
    })}
  </div>
);

export default ThemeToggle;
